'use client'
import { InputHTMLAttributes, forwardRef, useState } from 'react';
import styles from './AuthInput.module.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	label: string;
	error?: string;
	isPassword?: boolean;
}

export const AuthInput = forwardRef<HTMLInputElement, InputProps>(
	({ label, error, isPassword, type, ...props }, ref) => {
		const [showPassword, setShowPassword] = useState(false);

		const getInputType = () => {
			if (isPassword) {
				return showPassword ? 'text' : 'password';
			}
			return type;
		};

		return (
			<div className={styles.container}>
				<label className={styles.label}>{label}</label>
				<div className={styles.inputWrapper}>
					<input
						ref={ref}
						type={getInputType()}
						className={`${styles.input} ${error ? styles.inputError : ''}`}
						{...props}
					/>
					{isPassword && (
						<div>
							<div className={styles.divisor}></div>
							<button
								type="button"
								className={styles.toggleButton}
								onClick={() => setShowPassword(!showPassword)}
								aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
							>
								{showPassword ? <VisibilityOff /> : <Visibility />}
							</button>
						</div>
					)}
				</div>
				{error && <span className={styles.error}>{error}</span>}
			</div>
		);
	}
);

AuthInput.displayName = 'AuthInput';
